import Colors from 'assets/Colors';
import { useNavigate } from 'react-router-dom';
import s from './styles';

function MainMenuItem({ Icon, text, style, selected, path, onClick }) {
  const navigate = useNavigate();
  return (
    <s.ItemWrapper
      style={style}
      selected={selected}
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          navigate(path);
        }
      }}
    >
      <s.IconWrapper selected={selected}>
        <Icon
          size={32}
          color={selected ? Colors.icon_on_secondary : Colors.icon_secondary}
        />
      </s.IconWrapper>
      <s.TextWrapper>{text}</s.TextWrapper>
    </s.ItemWrapper>
  );
}

export default MainMenuItem;
